var map = {
	"./404.svg": "oUrx",
	"./account.svg": "7yJI",
	"./activity.svg": "Zzbb",
	"./add.svg": "wqOL",
	"./all.svg": "bWb3",
	"./applyList.svg": "Q1V9",
	"./approvalCenter.svg": "BgS3",
	"./aval.svg": "BjFM",
	"./bao.svg": "ktBc",
	"./baseInfo.svg": "xlth",
	"./bill.svg": "VIzg",
	"./brand.svg": "TGa0",
	"./bug.svg": "F3lI",
	"./businessAnalysis.svg": "7SHy",
	"./calculate.svg": "L27+",
	"./calendar.svg": "CHBr",
	"./chart.svg": "yCkv",
	"./checkDayList.svg": "nOwE",
	"./checkOrder.svg": "xSSX",
	"./clipboard.svg": "vDVG",
	"./collect.svg": "pVTs",
	"./collect_active.svg": "T+u/",
	"./commodity.svg": "L6Ul",
	"./component.svg": "VtY+",
	"./consignment.svg": "61yP",
	"./contract.svg": "7us4",
	"./copy.svg": "Gbaw",
	"./credit.svg": "rfw5",
	"./creditNote.svg": "dpEf",
	"./cstore.svg": "X/pc",
	"./customer.svg": "sX83",
	"./customerRelationship.svg": "kPI9",
	"./customersManagement.svg": "XMKc",
	"./dashboard.svg": "94Jb",
	"./dataanalysis.svg": "W+hA",
	"./del.svg": "0vkG",
	"./detailed.svg": "dMz2",
	"./documentation.svg": "kPu2",
	"./drag.svg": "m7++",
	"./edit.svg": "qkZ8",
	"./electronicArchives.svg": "lUyM",
	"./email.svg": "y7eQ",
	"./enterpriseText.svg": "WgXx",
	"./equal.svg": "84n0",
	"./erp.svg": "ejsR",
	"./example.svg": "MMMJ",
	"./excel.svg": "ZZmv",
	"./expand.svg": "yWNY",
	"./expectedShortage.svg": "xA/w",
	"./eye.svg": "TfVu",
	"./fcst.svg": "OVyX",
	"./filtrate.svg": "alGl",
	"./financeInvoice.svg": "f8BD",
	"./finish.svg": "kTvD",
	"./form.svg": "6xvN",
	"./global.svg": "kKEV",
	"./guide 2.svg": "ICep",
	"./guide.svg": "ZoO1",
	"./history.svg": "wCND",
	"./icon-fanshenhe.svg": "MfZ4",
	"./icon-shenhe.svg": "UnK7",
	"./icon.svg": "nZHn",
	"./idcard.svg": "tNhJ",
	"./income.svg": "niWv",
	"./infinity.svg": "YbZT",
	"./international.svg": "F9+T",
	"./inventory.svg": "+qd9",
	"./invoice.svg": "BUO5",
	"./isExpand.svg": "HMO1",
	"./language.svg": "JYDz",
	"./link.svg": "GPBF",
	"./lock.svg": "qwAt",
	"./look.svg": "xLvv",
	"./media.svg": "3gVd",
	"./merge.svg": "HI3S",
	"./message.svg": "R/8a",
	"./money.svg": "MEYL",
	"./mysql.svg": "tHv3",
	"./nested.svg": "3PhE",
	"./offset.svg": "kR3T",
	"./ownbrand.svg": "yKhp",
	"./pageComponent.svg": "55JQ",
	"./password.svg": "Kj24",
	"./payment.svg": "6k/e",
	"./people.svg": "0Fbn",
	"./peoples.svg": "LxGF",
	"./performance.svg": "03Wg",
	"./personalText.svg": "mcmZ",
	"./personnelStructure.svg": "EV+c",
	"./personnelmanagement.svg": "auy+",
	"./pie-chart.svg": "Rj2J",
	"./prepayment.svg": "4ZtY",
	"./product.svg": "jTAa",
	"./profitcenter.svg": "HHMJ",
	"./purchase.svg": "uPdf",
	"./purchaseList.svg": "0ard",
	"./purchaseSearch.svg": "dkAI",
	"./purchase_icon.svg": "F7mX",
	"./qq.svg": "FDDl",
	"./recharge.svg": "G1QG",
	"./refund.svg": "IT0I",
	"./registrationPaper.svg": "QlIk",
	"./request.svg": "6w/L",
	"./rollback.svg": "5wIC",
	"./search.svg": "jo2x",
	"./setting.svg": "Bf+v",
	"./shipping.svg": "6K4P",
	"./shopping.svg": "EqXK",
	"./sign.svg": "JJbQ",
	"./size.svg": "hkRB",
	"./smart.svg": "aOC+",
	"./staffAttendance.svg": "6afB",
	"./staffRecords.svg": "MR+w",
	"./star.svg": "cIpu",
	"./starOnline.svg": "XX5C",
	"./start.svg": "J0OD",
	"./stockList.svg": "EJwv",
	"./stockin.svg": "DKOb",
	"./stop.svg": "vbf9",
	"./summary.svg": "B7my",
	"./supplier.svg": "Wj5h",
	"./systemMonitoring.svg": "h0Xp",
	"./tab.svg": "j7e1",
	"./table.svg": "R/Hx",
	"./talentpool.svg": "4yll",
	"./tax.svg": "w9zF",
	"./taxManagement.svg": "6j5t",
	"./theme.svg": "5TQQ",
	"./todo.svg": "Yasm",
	"./transaction.svg": "8GJr",
	"./tree.svg": "k80C",
	"./unredo.svg": "KJaX",
	"./upload.svg": "nYLW",
	"./user.svg": "s7Vf",
	"./verify.svg": "+fDC",
	"./verifySuccess.svg": "q0U8",
	"./warehouse.svg": "qAXR",
	"./waste.svg": "em1H",
	"./wechat.svg": "gNoN",
	"./whiteList.svg": "nIqE",
	"./zip.svg": "iqZD"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uf/o";